import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_activity sub_page" }
const _hoisted_2 = { class: "sub_page_con wrap_1120" }
const _hoisted_3 = { class: "total_num" }
const _hoisted_4 = { class: "total_num_value" }
const _hoisted_5 = {
  key: 0,
  class: "btn_wrap _default right_btn _board_type"
}
const _hoisted_6 = { class: "con_gal sub_page_con_view" }
const _hoisted_7 = ["for"]
const _hoisted_8 = ["id", "onClick"]
const _hoisted_9 = {
  key: 1,
  class: ""
}
const _hoisted_10 = {
  key: 2,
  class: ""
}
const _hoisted_11 = {
  key: 3,
  class: ""
}
const _hoisted_12 = { class: "img_wrap" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  src: "img/no_img1.png",
  alt: ""
}
const _hoisted_15 = { class: "desc_wrap" }
const _hoisted_16 = ["textContent"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "con_date" }
const _hoisted_19 = { class: "con_info" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "info_data" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "info_data" }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { class: "info_data" }
const _hoisted_26 = { key: 3 }
const _hoisted_27 = { class: "info_data" }
const _hoisted_28 = { class: "info_data" }
const _hoisted_29 = ["for"]
const _hoisted_30 = ["id", "onClick"]
const _hoisted_31 = {
  key: 1,
  class: ""
}
const _hoisted_32 = {
  key: 2,
  class: ""
}
const _hoisted_33 = {
  key: 3,
  class: ""
}
const _hoisted_34 = { class: "img_wrap" }
const _hoisted_35 = ["src"]
const _hoisted_36 = {
  key: 1,
  src: "img/no_img1.png",
  alt: ""
}
const _hoisted_37 = { class: "desc_wrap" }
const _hoisted_38 = ["textContent"]
const _hoisted_39 = {
  key: 1,
  class: "tbody_li no_data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("span", null, "Total", -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString($setup.state.totalLength), 1)
        ]),
        ($setup.state.hasAuth)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                class: "common_btn _gray",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.isDelete && $setup.isDelete(...args)))
              }, "삭제"),
              _createVNode(_component_router_link, {
                class: "common_btn w_130",
                to: { name: 'ActivityWrite' }
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("글쓰기", -1)
                ]))]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", null, [
            ($setup.state.list.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass(["checkbox_wrap", [item.state === 1 ? '' : item.state === 2 ? 'active' : 'done']]),
                    key: item.idx
                  }, [
                    (!$setup.state.isMobile)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("label", {
                            for: item.idx,
                            class: "gal_tag"
                          }, [
                            ($setup.state.hasAuth)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    name: "chk",
                                    id: item.idx,
                                    onClick: ($event: any) => ($setup.selectedIdx(item.idx))
                                  }, null, 8, _hoisted_8),
                                  _cache[3] || (_cache[3] = _createElementVNode("em", null, null, -1))
                                ], 64))
                              : _createCommentVNode("", true),
                            (item.state === 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "진행전"))
                              : (item.state === 2)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "진행중"))
                                : (item.state === 3)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "진행완료"))
                                  : _createCommentVNode("", true)
                          ], 8, _hoisted_7),
                          _createVNode(_component_router_link, {
                            to: { name: 'ActivityView', params: { id: item.idx } }
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_12, [
                                (item.thumbnail)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: item.thumbnail,
                                      alt: ""
                                    }, null, 8, _hoisted_13))
                                  : (_openBlock(), _createElementBlock("img", _hoisted_14))
                              ]),
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("p", null, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass({ d_day_hour: $setup.CommonUtils.getDDayHour(new Date(item.recruitEndDate)) })
                                  }, _toDisplayString($setup.CommonUtils.getDDayHour(new Date(item.recruitEndDate))), 3)
                                ]),
                                _createElementVNode("p", {
                                  class: "con_tit elips_2",
                                  textContent: _toDisplayString(item.title)
                                }, null, 8, _hoisted_16),
                                _createElementVNode("p", {
                                  class: "con_desc elips_3",
                                  innerHTML: $setup.CommonUtils.decodeContent(item.content).replace(/<img[^>]*>/gi, '')
                                }, null, 8, _hoisted_17),
                                _createElementVNode("p", _hoisted_18, _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.createDate), ".", true)), 1),
                                _createElementVNode("div", _hoisted_19, [
                                  (item.recruitStartDate && item.recruitEndDate)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "info_tit" }, "모집기간", -1)),
                                        _createElementVNode("span", _hoisted_21, _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.recruitStartDate), ".", false) +
                                                    "-" +
                                                    $setup.CommonUtils.dateFormat(new Date(item.recruitEndDate), ".", false)), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (item.activeStartDate && item.activeEndDate)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "info_tit" }, "활동기간", -1)),
                                        _createElementVNode("span", _hoisted_23, _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.activeStartDate), ".", false) +
                                                    "-" +
                                                    $setup.CommonUtils.dateFormat(new Date(item.activeEndDate), ".", false)), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (item.applyDate)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                                        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "info_tit" }, "신청 마감", -1)),
                                        _createElementVNode("span", _hoisted_25, _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.applyDate), ".", false)), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (item.cntApply > 0)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                                        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "info_tit" }, "모집인원", -1)),
                                        _createElementVNode("span", _hoisted_27, _toDisplayString($setup.CommonUtils.numberFormat(item.cntApply)) + "명", 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("p", null, [
                                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "info_tit" }, "장소", -1)),
                                    _createElementVNode("span", _hoisted_28, _toDisplayString(item.address) + " " + _toDisplayString(item.addressDetail), 1)
                                  ])
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("label", {
                            for: item.idx,
                            class: "gal_tag"
                          }, [
                            ($setup.state.hasAuth)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    name: "chk",
                                    id: item.idx,
                                    onClick: ($event: any) => ($setup.selectedIdx(item.idx))
                                  }, null, 8, _hoisted_30),
                                  _cache[9] || (_cache[9] = _createElementVNode("em", null, null, -1))
                                ], 64))
                              : _createCommentVNode("", true),
                            (item.state === 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_31, "진행전"))
                              : (item.state === 2)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, "진행중"))
                                : (item.state === 3)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, "진행완료"))
                                  : _createCommentVNode("", true)
                          ], 8, _hoisted_29),
                          _createVNode(_component_router_link, {
                            to: { name: 'ActivityView', params: { id: item.idx } }
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_34, [
                                (item.thumbnail)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: item.thumbnail,
                                      alt: ""
                                    }, null, 8, _hoisted_35))
                                  : (_openBlock(), _createElementBlock("img", _hoisted_36))
                              ]),
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("p", {
                                  class: "con_tit elips_2",
                                  textContent: _toDisplayString(item.title)
                                }, null, 8, _hoisted_38)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ], 64))
                  ], 2))
                }), 128))
              : (_openBlock(), _createElementBlock("li", _hoisted_39, [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("div", { class: "tr_div" }, [
                    _createElementVNode("div", {
                      class: "tb_subject",
                      style: {"text-align":"center","width":"100%"}
                    }, "등록된 게시물이 없습니다.")
                  ], -1)
                ]))]))
          ])
        ]),
        ($setup.state.list.length !== 0)
          ? (_openBlock(), _createBlock(_component_PageBtn, {
              key: 1,
              currentPage: $setup.state.page,
              totalLength: $setup.state.totalLength,
              perPage: $setup.state.size,
              onOnPaging: $setup.handlePageChange
            }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
          : _createCommentVNode("", true)
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}